import React, { useState, useEffect } from "react";
import DashboardLayout from "../../molecules/DashboardLayout";
import {
  Row,
  Col,
  Pagination,
  Card,
  Space,
  Typography
} from "antd";
import { getBusinessUnitsTypes } from "../Organizations/ducks/actions";
import SectionHeader from "../../molecules/SectionHeader";
import Grid from "../../atoms/Grid";

import { getAdvertisements } from "./service";
import { Loader } from "../../atoms/Loader";
import {FilterOutlined,EyeOutlined, EditOutlined, CopyOutlined, DeleteOutlined} from "@ant-design/icons";
import { adminService } from "../../../configs/constants";
import Title from "antd/es/typography/Title";
import { Popup } from "../../atoms/Popup";
import UpdateAdvertisement from "./components/UpdateAdvertisement";

import axios from "../../../utils/axiosInceptor";



const { Text } = Typography;

const gridProps = {
  sortable: true,
  filter: true,
  resizable: true,
  minWidth: 200,
};

const limit = 20;

const searchKeys = [{ value: "name", label: "Name", default: true },
{ value: "phone", label: "Phone" },
{ value: "email", label: "Email" }];

export default (props) => {
  

  const [adsData, setAdsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [status, setStatus] = useState(null);
  const[adCreatedFlag,setAdCreatedFlag] = useState(false);
  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const [loading, setLoading] = useState(false);
  const [viewNoticeAction, setAction] = useState(null);
  const[singleAddData,setSigleAddData] = useState(null);
  const [totalCount,setTotoalCount] = useState(0);
  const [orgList, setOrgList] = useState([]);
  const [screenList, setScreenList] = useState([]);
  
  const configData = `${adminService}/configData`;

  const getAllAds = async ()=>{
      setLoading(true);
    try{
      let allAds = await getAdvertisements({currentPage,limit});

      if(allAds?.data?.result?.data){
        setLoading(false);
        setTotoalCount(allAds?.data?.result?.totalCount);
        setAdsData(allAds?.data?.result?.data);
      }
      
    }catch(e){
      setLoading(false);
     console.log(e)
    }
  }

  const getOrganizations = async () => {

    const url = `${adminService}/organization/list?status=enable`;
    try {

      const { data } = await axios.get(url);

      if (data?.result) {

        let orgData = [];

        data?.result?.forEach((org) => {
          orgData.push({
            label: org.name,
            value: org?.orgId
          })
        });

        setOrgList(orgData);
      }

    } catch (error) {
      console.log(error)
    }
  }

  const getTenantScreens = async()=>{
    try {
      const { data: { result }} = await axios.get(`${configData}?key=tenantAppScreenList`);

      let screens = [];

      result[0]?.tenantAppScreenList?.forEach((item)=>{
        screens?.push({
          label:item,
          value:item
        })
      });
      setScreenList(screens);
    } catch (e) {
      console.log({ e });
    }
  }
  
  useEffect(()=>{
    getOrganizations();
    getTenantScreens();
  },[]);
  useEffect(() => {
    getAllAds();
  }, [currentPage,adCreatedFlag]);

  const noticeCol = [
    {
      headerName: "Status",
      field: "status",
      key: "status",
      minWidth: 190,
      cellRendererFramework: ({ data }) => {
        return (
          <Space size={24}>
            {
            data.status
            }
          </Space>
        );
      },
    },
    {
      headerName: "Title",
      field: "title",
      key: "title",
      minWidth: 220,
    },
    {
      headerName: "Start Date",
      field: "startDate",
      key: "startDate",
      minWidth: 200,
      cellRendererFramework:(({data})=>{
        return (
          <p>{data?.startDate && data?.startDate?.slice(0,10)}</p>
        )
      })
    },
    {
      headerName: "End Date",
      field: "endDate",
      key: "endDate",
      minWidth: 200,
      cellRendererFramework:(({data})=>{

        return (
          <p>{data?.endDate && data?.endDate.slice(0,10)}</p>
        )
      })
    },
    {
      headerName: "Type",
      field: "type",
      key: "type",
      minWidth: 140,
    },
   
    {
      headerName: "Actions",
      field: "actions",
      key: "actions",
      minWidth: 160,
      cellRendererFramework: ({ data }) => {
        return (
          <Space size={16}>    

            <EyeOutlined className="icons-page" onClick={() => viewAction('View', data)} /> 
            
            {
              <EditOutlined className="icons-page" onClick={() => viewAction('Edit', data)} /> 
            }
          </Space>
        );
      },
    },
  ];

  const viewAction = (action, notice) => {
    setAction(action);
    setSigleAddData(notice);
    setVisible(true);
  }

  const onAdd = () => {
    setVisible(false);
  };

  const handlePagination = (pg) => {
    setCurrentPage(pg);
    
  };

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          {viewNoticeAction ? `${viewNoticeAction} Advertisement` : "Create Advertisement"} 
        </Title>
      ),
      content: (
        <UpdateAdvertisement
          onSubmit={onAdd}
          adCreatedFlag={adCreatedFlag}
          setAdCreatedFlag={setAdCreatedFlag}
          onCancel={() => setVisible(false)}
          orgList={orgList}
          screenList={screenList}
          singleAddData={
            (
              viewNoticeAction === 'Edit' || 
              viewNoticeAction === 'View'
            ) ?
            singleAddData :
            null
          }
          action={viewNoticeAction}
          setAction={setAction}
        />
      ),
      width: 700,
    }
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };

  const setFilter = (statusFilter) => {
    setStatus(statusFilter);
    setCurrentPage(1);
  }

  useEffect(() => {
    setFilter('')
  }, [])

  return (
    <>
      <DashboardLayout load={loading}>

        {
          loading ?
         <Loader height={60} />
          :
          <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <SectionHeader
                  heading="Advertisement"
                  noBorder={true}
                  total={totalCount}
                  // addNewAction={ addTenant }
                  // dropNewAction={onDropClick}
                  // dropItems={MenuItems}
                  // dropTrigger={["click"]}
                  addNewAction={() => {
                    setAction(null)
                    setVisible(true)}
                  }
                  // search={(e) => onTopSearch(e)}
                  // searchBy={(e) => onTopSearchBy(e)}
                //   searchOptions={searchKeys}
                //   defaultSearch={search}

                  // viewOption={propertyOptions}
                  viewOptionIcon={<FilterOutlined />}
                  // viewOptionLabel="Filter by : property/unit"
                  justifiedItems={true}
                  // updateValue={updateValue}
                  justifyEnd={true}
                />
              </Col>
              <Col span={24}>
                <Pagination
                  pageSize={limit}
                  className="ag-property-text-pagination"
                  total={totalCount}
                  showTotal={(total, range) =>
                    `Showing ${range[0]}-${range[1]} of ${total} Advertisements`
                  }
                  defaultPageSize={10}
                  defaultCurrent={1}
                  showSizeChanger={false}
                  current={currentPage}
                  onChange={(e) => handlePagination(e)}
                />
              </Col>
              <Col span={24}>
                

               {
                
                <Row gutter={[24, 24]} justify="end">
                  <Col span={24}>
                    <Card
                      bordered={false}
                      className="ag-nospace-body"
                    // extra={<SearchFelds />}
                    >
                      
                      <Grid
                        refCol="status"
                        data={adsData}
                        columns={noticeCol}
                        autoSizeColumns={true}
                        pagination={false}
                        defaultSettings={gridProps}
                        noRowlabel="Advertisements"
                        fullPage={true}
                      />

                    </Card>
                  </Col>
                </Row>
                }

              </Col>
            </Row>
          </Col>
        </Row>
        }

      </DashboardLayout>
      <Popup destroyOnClose={true} {...popupProps} />
    </>
  );
};